<template>
<div>
    <base-header v-once pageName="관심 및 무진 정보" :popup="true"></base-header>
    
    <section id="wrap">

        <h3 class="attn-title">관심 정보</h3>
        <dl class="attn">
            <dt>교육 관심도</dt>
            <dd class="flex-between">
                <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CED' )" :key="index">
                    <input type="radio" :name="code.prenCd" v-model="valueOfCED" :value="code.cdVl1" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>교육 관심분야</dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CEC' )" :key="index">
                    <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>교육 정보 출처</dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CIP' )" :key="index">
                    <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>학습 활동</dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CLA' )" :key="index">
                    <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>관심 전집</dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CMC' )" :key="index">
                    <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>교육비(월)</dt>
            <dd class="grid">
                <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CMM' )" :key="index">
                    <input type="radio" :name="code.prenCd" v-model="valueOfCMM" :value="code.cdVl1" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dt>관심도구</dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CDS' )" :key="index">
                    <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1" :disabled="chkDisabled()">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
        </dl>
        <h3 class="attn-title">무진 활동</h3>
        <dl class="attn">
            <dt>무진활동을 선택해주세요.</dt>
            <dd class="grid">
                <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CRD' )" :key="index">
                    <input type="radio" :name="code.prenCd" v-model="myCstmr.prensrno" :value="code.cdVl1" :id="code.cdVl1" :disabled="chkDisabled()" @click="checkCRD(code.cdVl1)">
                    <label :for="code.cdVl1">{{code.cdNm}}</label>
                </span>
            </dd>
            <dd>
                <input type="text" 
                    ref="custnote" 
                    v-model="myCstmr.custnote" 
                    id="custnote" 
                    :disabled="chkDisabled()" 
                    placeholder="기타 선택 시 장소 입력해주세요.(예 : oo공원 앞)"  
                    v-show="showEtc">
            </dd>
        </dl>
       
    </section>
    <div v-if="custDiv =='SCD02'" class="btnWrap">
        <button type="button" class="red" @click="modify">수정</button>
    </div>
</div>
</template>

<script>
export default {
  data() {
      return{
          activeTab: "first",
          tabWrap: true,
          myCstmr: {},
          custInterestInfoList: [],
          valueOfCED: "",
          valueOfCMM: "",
          custDiv: "SCD02", //SCD01: 계약, SCD02: 가망
          showEtc: false,
      };
  },
  methods: {
    tabCur: function(name) {
        if(this.activeTab != name){
            console.log('000', name)
            this.tabWrap = !this.tabWrap;
        }
        this.activeTab = name;
    },
    chkDisabled: function() {
        return this.custDiv == 'SCD01'?true:false;
    },
    checkCRD: function(cdVl1) {
        // console.log("cdVl1 ",cdVl1);
        // console.log("this.myCstmr.prensrno ",this.myCstmr.prensrno);
        // console.log("this.myCstmr.custnote ",this.myCstmr.custnote);
        if("78" != cdVl1){ // 무진활동 기타가 아닐 때
            this.showEtc = false;
            this.myCstmr.custnote = '';
        }else{
            this.showEtc = true;
            this.$nextTick(() => {
                this.$refs.custnote.focus();
            })
        }
    },
    modify: function() {
      //var that = this;
        //   console.log("this.myCstmr.prensrno:", this.myCstmr.prensrno);
        //   console.log("this.myCstmr.custnote:", this.myCstmr.custnote);
        if('78' == this.myCstmr.prensrno && this.$utils.stringUtil.isNull(this.myCstmr.custnote) ){ // 무진활동 기타 선택 후 장소 미 입력시
            alert("기타 선택 시 장소 입력해주세요.");
            return;
        }
            if(!confirm("관심 및 무진정보를 저장하시겠습니까?")){
            return;
        }

        // 선택된 교육 관심도는 Y, 나머지는 N이 셋팅
        var interestCED = this.custInterestInfoList.filter(interest => interest.prenCd === "CED");
        for(var i=0; i < interestCED.length; i++){
            console.log("interestCED[i]", interestCED[i]);
            if(interestCED[i].cdVl1 == this.valueOfCED){
                interestCED[i].custvalu = "Y";
            }else{
                interestCED[i].custvalu = "N";
            }
        }
            
        // 선택된 교육비(월)은 Y, 나머지는 N이 셋팅
        var interestCMM = this.custInterestInfoList.filter(interest => interest.prenCd === "CMM");
        for(var j=0; j < interestCMM.length; j++){
            console.log("interestCMM[j]", interestCMM[j]);
            if(interestCMM[j].cdVl1 == this.valueOfCMM){
                interestCMM[j].custvalu = "Y";
            }else{
                interestCMM[j].custvalu = "N";
            }
        }
      
      var child = {
        name: "interestinfo-update-result",
        data: {
                myCstmr:this.myCstmr,
                custInterestInfoList:this.custInterestInfoList
            }
      };
      console.log("InterestInfo.vue modify child",child);
      this.$utils.nativeIf.outbound.sendChildData(child);

    },
      
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'interestInfo-pop-param'){  // 부모창에서 받은 정보.
            console.log("InterestInfo.vue mounted this.$store.getters.parent.data", parent.data);
            this.myCstmr = parent.data.myCstmr;
            this.custDiv = parent.data.custDiv;
            this.custInterestInfoList = parent.data.custInterestInfoList;
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'interestInfo-pop-param',
                data: {
                        myCstmr:""
                        ,custDiv:"SCD02"
                        ,custInterestInfoList: ""
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);

            // 교육 관심도 선택된 값 설정
            var interestCED = this.custInterestInfoList.find(interest => interest.prenCd === "CED" && interest.custvalu ==="Y");
            if(interestCED){
                this.valueOfCED = interestCED.cdVl1;
            }
            // 교육비(월) 선택된 값 설정
            var interestCMM = this.custInterestInfoList.find(interest => interest.prenCd === "CMM" && interest.custvalu ==="Y");
            if(interestCMM){
                this.valueOfCMM = interestCMM.cdVl1;
            }
        }
  }
};
</script>
